import { Link } from "react-router-dom";
import { Receipt } from "lucide-react";
import { downloadBlob } from "@/lib/workflow";

export function InvoiceCard({ data }) {
  if (data.du_status !== "zugesagt" || !data.order_no) return null;
  const inv = data.invoice_doc;
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5 shadow-sm" data-testid="adp-invoice-card">
      <div className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-3">Rechnung</div>
      {inv ? (
        <div className="text-sm space-y-1">
          <div className="font-semibold" data-testid="adp-invoice-no">{inv.number} <span className={`ml-1 text-[11px] px-1.5 py-0.5 rounded ${inv.status === "bezahlt" ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"}`}>{inv.status}</span></div>
          <div className="text-xs text-slate-500">{inv.sent_at ? `versendet am ${new Date(inv.sent_at).toLocaleDateString("de-DE")}` : "noch nicht versendet"}</div>
          <div className="flex gap-3 text-xs pt-1">
            <button type="button" className="underline font-semibold" onClick={() => downloadBlob(`/documents/${inv.id}/file`, {}, inv.filename)} data-testid="adp-invoice-download">E-Rechnung (PDF)</button>
            {inv.drive_link && <a href={inv.drive_link} target="_blank" rel="noreferrer" className="underline">in Google Drive</a>}
          </div>
        </div>
      ) : (
        <div className="text-sm text-slate-600 space-y-2" data-testid="adp-invoice-hint">
          <div>Noch keine Rechnung. Die Rechnung wird in der Buchhaltung erstellt und dort gedruckt oder per Mail versendet.</div>
          <Link to="/buchhaltung" className="inline-flex items-center gap-1.5 text-xs font-semibold underline" data-testid="adp-invoice-goto"><Receipt size={14} /> Zur Buchhaltung</Link>
        </div>
      )}
    </div>
  );
}
